import {PropTypes as mobxTypes} from 'mobx-react';
import PropTypes from 'prop-types';

import {useI18n} from '@udemy/i18n';
import TrendingGraphIcon from '@udemy/icons/dist/trending-graph.ud-icon';
import WarningIcon from '@udemy/icons/dist/warning.ud-icon';
import {Loader} from '@udemy/react-reveal-components';

import {BROWSE_OBJECT_TYPES, BrowseLink} from '../browse-link/browse-link.react-component';
import styles from './topic-list-collection.module.less';

interface TopicItem {
    _class: string;
    id: number;
    title: string;
    url: string;
    icon_class: string;
    type: string;
}

export type TopicItems = Array<{
    sd_tag: TopicItem;
    inner_sd_tag: TopicItem;
}>;

export interface TopicTableRowsProps {
    items: TopicItems;
}

const TopicTableRows = ({items}: TopicTableRowsProps) => {
    const {gettext} = useI18n();

    const rows = items.map((item, i) => {
        const topic = item.sd_tag;
        const subcategory = item.inner_sd_tag;
        const popularInText = gettext('Popular in');
        return (
            <tr data-testid="topic-table" key={i}>
                <td className={styles['topic-id']}>{i + 1}</td>
                <td className={styles['topic-title']}>
                    <BrowseLink browseObject={{...topic, type: BROWSE_OBJECT_TYPES.COURSE_LABEL}}>
                        {topic.title}
                    </BrowseLink>
                </td>
                <td className={styles['topic-stats']}>
                    <>
                        <TrendingGraphIcon
                            label={popularInText}
                            className={styles['trending-icon']}
                        />
                        <span role="cell">
                            {popularInText}
                            <BrowseLink
                                className={styles['topic-stats-browse-link']}
                                browseObject={{...subcategory, type: 'subcategory'}}
                            >
                                {subcategory.title}
                            </BrowseLink>
                        </span>
                    </>
                </td>
            </tr>
        );
    });
    return <tbody>{rows}</tbody>;
};

export interface TopicTableProps {
    items: TopicItems;
    isLoading: boolean;
}

export const TopicTable = ({items, isLoading}: TopicTableProps) => {
    const {gettext} = useI18n();

    const loader = <Loader size="medium" />;

    if (!items.length && isLoading) {
        return <p>{loader}</p>;
    }

    if (!items.length) {
        const text = gettext('There is no data');
        return (
            <p>
                <WarningIcon label={text} /> {text}
            </p>
        );
    }
    return (
        <table className={styles['topic-list']}>
            <TopicTableRows items={items} />
        </table>
    );
};

TopicTable.propTypes = {
    items: mobxTypes.arrayOrObservableArray,
    isLoading: PropTypes.bool,
};

TopicTable.defaultProps = {
    items: [],
    isLoading: false,
};
